import React from 'react';
import { Card } from '@/components/ui';
import type { SystemUsage } from '../../types/dashboard.types';

interface SystemUsageWidgetProps {
  usage: SystemUsage;
}

export function SystemUsageWidget({ usage }: SystemUsageWidgetProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm flex flex-col h-[280px]">
      <h3 className="font-medium text-slate-900 mb-6">Sử dụng hệ thống</h3>
      
      <div className="grid grid-cols-3 gap-6 flex-1">
        <div className="flex flex-col border border-slate-100 rounded-xl p-5 bg-white shadow-sm relative overflow-hidden">
          <p className="sm:text-sm text-xs font-medium text-slate-500 mb-3">Lưu trữ đã dùng</p>
          <div className="flex items-end gap-1 mb-6">
            <span className="text-2xl font-black text-slate-900">{usage.storage.used}</span>
            <span className="sm:text-sm text-xs font-medium text-slate-900 mb-1">{usage.storage.unit}</span>
            <span className="sm:text-sm text-xs text-slate-400 mb-1 ml-1">/ {usage.storage.total} {usage.storage.unit}</span>
          </div>
          <div className="mt-2">
            <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden mb-2">
              <div className="bg-emerald-500 h-2 rounded-full" style={{ width: `${usage.storage.pct}%` }}></div>
            </div>
            <div className="flex justify-between sm:text-sm text-xs font-medium text-slate-500">
              <span className="text-slate-700">{usage.storage.pct}%</span>
              <span>{usage.storage.pct}%</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col border border-slate-100 rounded-xl p-5 bg-white shadow-sm relative overflow-hidden">
          <p className="sm:text-sm text-xs font-medium text-slate-500 mb-3">Băng thông</p>
          <div className="flex items-end gap-1 mb-6">
            <span className="text-2xl font-black text-slate-900">{usage.bandwidth.used}</span>
            <span className="sm:text-sm text-xs font-medium text-slate-900 mb-1">{usage.bandwidth.unit}</span>
            <span className="sm:text-sm text-xs text-slate-400 mb-1 ml-1">/ {usage.bandwidth.total} {usage.bandwidth.unit}</span>
          </div>
          <div className="mt-2">
            <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden mb-2">
              <div className="bg-emerald-500 h-2 rounded-full" style={{ width: `${usage.bandwidth.pct}%` }}></div>
            </div>
            <div className="flex justify-between sm:text-sm text-xs font-medium text-slate-500">
              <span className="text-slate-700">{usage.bandwidth.pct}%</span>
              <span>{usage.bandwidth.pct}%</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col border border-slate-100 rounded-xl p-5 bg-white shadow-sm relative overflow-hidden">
          <p className="sm:text-sm text-xs font-medium text-slate-500 mb-3">API Requests</p>
          <div className="flex items-end gap-1 mb-6">
            <span className="text-2xl font-black text-slate-900">{usage.api.used}</span>
            <span className="sm:text-sm text-xs font-medium text-slate-900 mb-1">{usage.api.unit}</span>
            <span className="sm:text-sm text-xs text-slate-400 mb-1 ml-1">/ {usage.api.total}{usage.api.unit}</span>
          </div>
          <div className="mt-2">
            <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden mb-2">
              <div className="bg-emerald-500 h-2 rounded-full" style={{ width: `${usage.api.pct}%` }}></div>
            </div>
            <div className="flex justify-between sm:text-sm text-xs font-medium text-slate-500">
              <span className="text-slate-700">{usage.api.pct}%</span>
              <span>{usage.api.pct}%</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
